export default __webpack_public_path__ + "media/craigVid.af33f2ad.mp4";